import { connect } from 'react-redux';
import { requestProposals, requestBidsets } from '../modules/tour';

import TourTodo from './TourTodo';

const mapDispatchToProps = {
  requestBidsets,
  requestProposals,
};

const mapStateToProps = state => ({
  proposals: state.tours.selectedTour.proposals,
  bids: state.tours.selectedTour.bids,
  bidNeedFetch: state.tours.selectedTour.fetches.bids.needFetch,
  proposalNeedFetch: state.tours.selectedTour.fetches.proposals.needFetch,
  isFetching:
    state.tours.selectedTour.fetches.proposals.isFetching &&
    state.tours.selectedTour.fetches.bids.isFetching,
});
const TourTodoContainer = connect(mapStateToProps, mapDispatchToProps)(TourTodo);
export default TourTodoContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourTodoContainer.js